import React, { Component } from 'react';
import { Parallax } from "react-parallax";

export class PolicyOrgPage extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <section id="terms-of-services">
                <Parallax blur={4} bgImage="../img/parallax-bg-6.jpg" strength={500} className="parallax-display">
                    <div className="w-100" style={{ height: 500, width: 100 }} />
                    <div className="parallax-box">Terms of Services</div>
                </Parallax>
                <div className="p-5 body-lt">
                    <h2 className="kurb-med">Terms</h2>
                    <p className="pt-4">
                        SpeNeeds seeks for a fulfilling, rich community experience for all. Therefore, any breaches against
                        our faciltaing terms will not be tolerated. We ask of our organizers to follow these guidelines:
                    </p>
                    <ol className="pt-2">
                        <li className="p-2">Upload appropriate program and event cover photos</li>
                        <li className="p-2">Answer member questions with respect</li>
                        <li className="p-2">Post only events relavent to the SpeNeeds mission</li>
                        <li className="p-2">Promote legitimate programs and events</li>
                        <li className="p-2">Inappropriate soliciting is prohibited</li>
                        <li className="p-2">Inappropriate contact with members is not allowed</li>
                    </ol>

                    <h2 className="pt-5 kurb-med">Termination</h2>
                    <p className="pt-4">
                        Failure to follow SpeNeed guidelines and terms will result in immediate termination or suspension from SpeNeeds,
                        with or without prior notice. SpeNeeds has the right to terminate your account and to contact any participants who
                        may be potentially involved. Violation of our policy will result in indefinte suspension and will affect your chance
                        of retaining your organization's membereship and ability to promote on SpeNeeds. Subsequent applications to rejoin
                        our website will be put under weary caution.
                    </p>
                    <h2 className="pt-5 kurb-med">Thank you</h2>
                    <p>
                        Thanks for following our guidelines. We hope to have everyone following our simple guidelines to provide the greatest
                        quality of experience for the community! :)
                    </p>
                </div>
            </section>
        );
    }
}